<template>
  <div class="feedbackBtn_box" @click="goFeedback">
    <div class="tip_box">
      <span class="tip_text">反馈</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'XmFeedbackBtn',
  methods: {
    goFeedback() {
      this.$router.push('/feedback');
    },
  },
};
</script>

<style scoped lang="scss">
.feedbackBtn_box {
  /* 用户体验反馈按钮 */
  position: fixed;
  bottom: 346px;
  right: 60px;
  z-index: 2001;
}

.tip_box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 56px;
  height: 56px;
  background: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
  opacity: 1;
  border-radius: 100%;
  line-height: 56px;
  text-align: center;
  cursor: pointer;
  flex-direction: column;

  .tip_text {
    width: 28px;
    height: 16px;
    line-height: 16px;
    font-size: 12px;
    font-weight: 400;
    color: #808080;
  }

  .icon-fankui {
    position: absolute;
    width: 28px;
    height: 28px;
  }
}

.tip_box:hover {
  color: #ff7802;
  .tip_text {
    color: #ff7802;
  }
  .icon-fankui path {
    fill: #ff7802;
  }
}
</style>
